if (!customElements.get('brand-index')) {
  class BrandIndex extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('.brand-index__nav');
      this.groups = Array.from(this.querySelectorAll('.brand-index__group'));
      if (!this.nav || this.groups.length === 0) return;

      this.allButton = this.nav.querySelector('[data-letter="all"]');
      // The "all" reset only makes sense once filtering works, so it stays
      // hidden for no-JS visitors (letter links degrade to anchor jumps).
      if (this.allButton) this.allButton.hidden = false;

      this.nav.addEventListener('click', this.handleNavClick.bind(this));
    }

    handleNavClick(event) {
      const target = event.target.closest('[data-letter]');
      if (!target || target.classList.contains('is-disabled')) return;
      event.preventDefault();
      this.filterBy(target.dataset.letter);
    }

    filterBy(letter) {
      this.nav.querySelectorAll('[data-letter]').forEach((el) => {
        const active = el.dataset.letter === letter;
        el.classList.toggle('is-active', active);
        if (active) {
          el.setAttribute('aria-current', 'true');
        } else {
          el.removeAttribute('aria-current');
        }
      });
      this.groups.forEach((group) => {
        group.hidden = letter !== 'all' && group.dataset.letter !== letter;
      });
    }
  }

  customElements.define('brand-index', BrandIndex);
}
